<template>
  <div>
    <div v-if="loading">Loading...</div>
    <div v-else>
      <div>
        <h3>{{ pageHeader }}</h3>
        <div id="PermitInfoTab" style="display: none">
          <applicant-info ref="applicantRef" />
          <footer-buttons @savePermit="savePermit" :index="0" :previousBtn="false" />
        </div>
        <div id="SiteOwnerInfoTab" style="display: none">
          <owner-info :owners="owners" ref="ownerRef" />
          <footer-buttons @savePermit="savePermit" :index="1" />
        </div>
        <div id="ContractorInfoTab" style="display: none">
          <contractor-info ref="contractorRef" />
          <footer-buttons @savePermit="savePermit" :index="2" />
        </div>
        <div id="ProjectInfoTab" style="display: none">
          <project-info :sites="sites" ref="projectInfoRef" />
          <footer-buttons @savePermit="savePermit" :index="3" />
        </div>
        <div id="InstallerDetailsTab" style="display: none">
          <installer-details ref="installerDetailsRef" />
          <footer-buttons @savePermit="savePermit" :index="4" />
        </div>
        <div id="InstallationInfoTab" style="display: none">
          <installation-details ref="installationDetailsGridRef" />
          <footer-buttons @savePermit="savePermit" :index="5" />
        </div>
        <div id="FacilityTankInfoTab" style="display: none">
          <facility-tank-info
            ref="facilityTankInfoRef"
            :forSingleWall="forSingleWall"
            :forDoubleWall="forDoubleWall"
          />
          <footer-buttons @savePermit="savePermit" :index="6" />
        </div>
        <div id="FOIPInfoTab" style="display: none">
          <foip-info @controlNavigationToReview="controlNavigationToReview" />
          <footer-buttons @savePermit="savePermit" :showNextButton="navigateToReview" :index="7" />
        </div>
        <div id="ReviewSummaryTab" style="display: none">
          <ul v-for="(err, index) in errorsArray" :key="index">
            <li class="e-error">
              <a href="#" @click="onErrorClick(err)" style="color: red">{{ err }}</a>
            </li>
          </ul>
          <review-summary
            ref="reviewSummaryRef"
            :forSingleWall="forSingleWall"
            :forDoubleWall="forDoubleWall"
            :feeDetails="feeDetails"
            :documents="documents"
            :documentsUploadInfo="documentsUploadInfo"
          />
          <footer-buttons
            ref="reviewFooterRef"
            :disabled="disabled"
            @submit="onSubmitAppl"
            :index="8"
          />
        </div>

        <div>
          <div tabindex="0" class="e-card" id="basic">
            <div class="e-card-content">
              <ejs-tab
                id="permitapplication_tab"
                class="e-background"
                ref="refPermitAppTabInstance"
                :selecting="tabSelect"
                :created="onTabCreation"
              >
                <e-tabitems>
                  <e-tabitem :header="permitTabs.headerText0" :content="permitTabs.content0" />
                  <e-tabitem :header="permitTabs.headerText1" :content="permitTabs.content1" />
                  <e-tabitem :header="permitTabs.headerText2" :content="permitTabs.content2" />
                  <e-tabitem :header="permitTabs.headerText3" :content="permitTabs.content3" />
                  <e-tabitem :header="permitTabs.headerText4" :content="permitTabs.content4" />
                  <e-tabitem :header="permitTabs.headerText5" :content="permitTabs.content5" />
                  <e-tabitem :header="permitTabs.headerText6" :content="permitTabs.content6" />
                  <e-tabitem :header="permitTabs.headerText7" :content="permitTabs.content7" />
                  <e-tabitem :header="permitTabs.headerText8" :content="permitTabs.content8" />
                </e-tabitems>
              </ejs-tab>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { TabPlugin } from "@syncfusion/ej2-vue-navigations";
import { mapActions, mapGetters } from "vuex";
import { CheckBoxPlugin, RadioButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { NumericTextBoxPlugin, TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import {
  AutoCompletePlugin,
  ComboBoxPlugin,
  DropDownListPlugin,
} from "@syncfusion/ej2-vue-dropdowns";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import ApplicantInfo from "../components/applicant-info.vue";
import OwnerInfo from "../components/owner-info.vue";
import ContractorInfo from "../components/contractor-info.vue";
import ProjectInfo from "../components/project-info.vue";
import InstallerDetails from "../components/installer-details.vue";
import FacilityTankInfo from "../components/facility-tank-info.vue";
import InstallationDetails from "../components/installation-details.vue";
import FoipInfo from "../components/foip-info.vue";
import ReviewSummary from "../components/review-summary.vue";
import {
  GET_COMPANIES,
  GET_COUNTRIES,
  GET_PROVINCES,
  STATIC_MESSAGE,
} from "../../user-accounts/store";
import { getSites } from "../../sites/services/site-api";
import FooterButtons from "../components/footer-buttons.vue";

import { FETCH_MUNICIPALITIES_LIST } from "../../search-requests/store";
import { GET_APPLICATIONWORKLISTS, SET_PERMIT } from "../store";
import {
  documentUploadDetails,
  fetchFeeDetails,
  getASTDoubleWall,
  getASTSingleWall,
  getUploadedDocuments,
  postPermit,
  submitApplication,
  updateApplicationWorkLists,
} from "../services/permitting-api";
import { dateRuleRegEx, emailRuleRegEx, phoneRuleRegEx } from "../../../shared/constants";
import { FETCH_SITE_OWNERS } from "../../settings/store";

Vue.use(TabPlugin);
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(AutoCompletePlugin);
Vue.use(ComboBoxPlugin);

export default {
  name: "PermitApplication",
  components: {
    ApplicantInfo,
    OwnerInfo,
    ContractorInfo,
    ProjectInfo,
    InstallerDetails,
    FacilityTankInfo,
    FoipInfo,
    ReviewSummary,
    InstallationDetails,
    FooterButtons,
  },
  data() {
    return {
      disabled: true,
      permitTabs: {
        headerText0: { text: "Applicant" },
        headerText1: { text: "Site Owner" },
        headerText2: { text: "Contractor" },
        headerText3: { text: "Project Location" },
        headerText4: { text: "Installer Details" },
        headerText5: { text: "Installation Information" },
        headerText6: { text: "Facility/Tank" },
        headerText7: { text: "FOIP" },
        headerText8: { text: "Review" },
        content0: "#PermitInfoTab",
        content1: "#SiteOwnerInfoTab",
        content2: "#ContractorInfoTab",
        content3: "#ProjectInfoTab",
        content4: "#InstallerDetailsTab",
        content5: "#InstallationInfoTab",
        content6: "#FacilityTankInfoTab",
        content7: "#FOIPInfoTab",
        content8: "#ReviewSummaryTab",
      },
      forSingleWall: null,
      forDoubleWall: null,
      pageHeaders: {
        STSWP: "STS Work Permit Application",
        STSRWP: "STS Removal & Work Permit Application",
        STSRP: "STS Removal Permit Application",
      },
      pageHeader: null,
      sites: null,
      loading: true,
      navigateToReview: true,
      feeDetails: null,
      errorsArray: [],
      documents: null,
      documentsUploadInfo: null,
    };
  },

  computed: {
    ...mapGetters({
      loggedUser: "loggedUser",
      permit: "permit",
      companies: "companies",
      municipalities: "getMunicipalities",
      applicationWorkLists: "applicationWorkLists",
      owners: "owners",
    }),
  },

  watch: {
    errorsArray(errorsArray) {
      this.disabled = !this.permit.printName || errorsArray.length > 0;
    },
  },

  beforeRouteEnter(_, _1, next) {
    next((thiss) => {
      // eslint-disable-next-line no-param-reassign
      thiss.pageHeader = thiss.pageHeaders[thiss.$route.query.permitType];
    });
  },

  async created() {
    const { ePermitId } = this.$route.query;
    if (ePermitId) {
      await this.fetchPermit({ ePermitId });
      await this.fetchApplicationWorkList(ePermitId);
    } else {
      if (!this.permit.requestor) { // if the page is reloaded
        this.redirectToStart();
      }
      await this.fetchApplicationWorkList();
    }
    this.permit.productCode = this.$route.query.permitType;
    this.sites = (await getSites()).data;

    await Promise.all([
      this.fetchCompanies(),
      this.fetchSiteOwners(),
      this.fetchMuniciPalities(),
      this.getCountries(),
      this.getProvinces(),
      getASTSingleWall().then((resp) => {
        this.forSingleWall = resp.data;
      }),
      getASTDoubleWall().then((resp) => {
        this.forDoubleWall = resp.data;
      }),
    ]);
    this.loading = false;

    this.getFOIPStaticMessage({ messageType: "foip" });
    this.fetchPermit({ permit: this.permit });
    this.disabled = this.errorsArray.length > 0 || !this.permit.printName;
  },

  methods: {
    ...mapActions({
      getProvinces: GET_PROVINCES,
      getCountries: GET_COUNTRIES,
      fetchCompanies: GET_COMPANIES,
      fetchMuniciPalities: FETCH_MUNICIPALITIES_LIST,
      fetchApplicationWorkList: GET_APPLICATIONWORKLISTS,
      fetchPermit: SET_PERMIT,
      getFOIPStaticMessage: STATIC_MESSAGE,
      fetchSiteOwners: FETCH_SITE_OWNERS,
    }),
    async tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      } else {
        this.onIndexChange(e);
      }
    },
    onTabCreation() {
      this.controlNavigationToReview(this.permit.foip);
    },

    onErrorClick(err) {
      let index = null;
      if (err.toLowerCase().includes("applicant")) index = 0;
      else if (err.toLowerCase().includes("owner")) index = 1;
      else if (err.toLowerCase().includes("contractor")) index = 2;
      else if (err.toLowerCase().includes("project location")) index = 3;
      else if (err.toLowerCase().includes("installer details")) index = 4;
      else if (err.toLowerCase().includes("installation information")) {
        index = 5;
      } else if (err.toLowerCase().includes("facility/tank")) index = 6;
      if (index >= 0) this.$refs.reviewFooterRef.selectTab(index);
    },
    onIndexChange(e) {
      if (e.event) {
        this.savePermit({
          newIndex: e.selectingIndex,
          currentIndex: e.selectedIndex,
          showSaveNotification: false,
        });
      }
    },
    redirectToStart() {
      const ptype = this.$route.query.permitType;
      if (ptype) this.$router.push({ name: ptype, query: { permitType: ptype } });
      else this.$router.push('/');
    },
    addDocuments(document) {
      this.documents.push(document);
      this.showToastNotification("Success !", "File uploaded succesfully", "e-toast-success");
    },

    deleteDocument(documentId) {
      this.documents.splice(
        this.documents.findIndex((x) => x.appDocumentDocumentId === documentId),
        1,
      );
      this.showToastNotification("Success !", "Document deleted succesfully", "e-toast-success");
    },

    showToastNotification(title, content, cssClass) {
      this.$parent.$parent.notificationToasts.push({
        title,
        content,
        cssClass,
        timeOut: 5000,
      });
      this.$parent.$parent.$refs.notifierRef.show();
    },

    async savePermit(data) {
      // update tanks
      // if user did not login or logout already then show error message.
      if(!this.loggedUser){
        this.showToastNotification(
              "Error !",
              "Your session is timeout, please login and keep working on this application.",
              "e-toast-danger",
            );
        return;
      }
      const { facilityTankInfoRef } = this.$refs;
      this.permit.ePermitSite.eSiteTanks = [
        ...facilityTankInfoRef.tanksToRemove,
        ...facilityTankInfoRef.tanksToInstall,
      ];
      // ---------------------------------------------

      const { showSaveNotification } = data;
      const { newIndex } = data;
      const { currentIndex } = data;
      // this.permit.requestorEmail = this.loggedUser.userName;

      if (this.permit.estStartDate < new Date("01/01/2018")) {
        this.permit.estStartDate = null;
      }
      if (this.permit.estEndDate < new Date("01/01/2018")) {
        this.permit.estEndDate = null;
      }
      // Installation info is not linked to permit right now , so saving it separately
      await postPermit(JSON.stringify(this.permit))
        .then(async (res) => {
          const permit = res.data;
          this.fetchPermit({ permit });
          const { ePermitId } = permit;
          this.$router
            .push({
              query: { ...this.$route.query, ePermitId },
            })
            .catch(() => {});
          if (currentIndex === 5) {
            this.applicationWorkLists.forEach(
              // eslint-disable-next-line no-return-assign, no-param-reassign
              (x) => (x.ePermitId = res.data.ePermitId),
            );
            await updateApplicationWorkLists(JSON.stringify(this.applicationWorkLists));
          }
          if (newIndex === 8) {
            // eslint-disable-next-line no-shadow
            await fetchFeeDetails(ePermitId).then((res) => {
              this.feeDetails = res.data[0].applicationFeeDetails;
            });
            // eslint-disable-next-line no-shadow
            await getUploadedDocuments(ePermitId).then((res) => {
              this.documents = res.data;
            });
            // eslint-disable-next-line no-shadow
            await documentUploadDetails().then((res) => {
              this.documentsUploadInfo = res.data;
              this.documentsUploadInfo.forEach((x) => {
                // eslint-disable-next-line no-param-reassign
                x.description = x.description.split("<br>");
              });
            });
            this.validatePermitValues();
          }
        })
        .then(() => {
          if (showSaveNotification) {
            this.showToastNotification("Success !", "Permit saved successfully", "e-toast-success");
          }
        })
        .catch(() => {
          // leo update it even error still show validation message
          this.validatePermitValues();
          if (showSaveNotification) {
            this.showToastNotification(
              "Error !",
              "Error occurred while saving permit",
              "e-toast-danger",
            );
          }
        });
    },

    controlNavigationToReview(isAgreed) {
      this.$refs.refPermitAppTabInstance.enableTab(8, isAgreed);
      this.navigateToReview = isAgreed;
    },

    validateDate(value, message, dateRef, tabInfo = null) {
      let isValid = false;
      const errMessage = `Please enter valid ${message} in format (MM/DD/yyyy) ${
        tabInfo ? `(${tabInfo} page)` : ""
      }`;
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(Date.parse(value))) {
        // eslint-disable-next-line no-param-reassign
        value = new Date(value).toLocaleDateString("en-US");
        if (!dateRuleRegEx.test(value)) {
          this.errorsArray.push(errMessage);
          dateRef.classList.add("e-error");
        } else {
          dateRef.classList.remove("e-error");
          isValid = true;
        }
      } else {
        this.errorsArray.push(errMessage);
        dateRef.classList.add("e-error");
      }
      return isValid;
    },

    validateContact(obj, message, contactRef) {
      Object.keys(obj).forEach((x) => {
        // eslint-disable-next-line default-case
        switch (x) {
          case "email":
            if (message === "applicant" && (!obj.email || obj.email === "")) {
              contactRef.$refs.applicantEmail.classList.add("e-error");
              // eslint-disable-next-line no-param-reassign
              contactRef.showErrorLabelEmail = true;
              this.$refs.reviewSummaryRef.$refs[`${message}Email`].classList.add("e-error");
              // eslint-disable-next-line no-param-reassign
              contactRef.errorLabelMessageEmail = "Please enter valid email";
              this.errorsArray.push("Applicant email is required (applicant page)");
            } else {
              this.validateEmail(obj.email, message, contactRef);
            }
            break;
          case "phone":
            if (message === "applicant" && (!obj.phone || obj.phone === "")) {
              contactRef.$refs.applicantPhone.classList.add("e-error");
              // eslint-disable-next-line no-param-reassign
              contactRef.showErrorLabelPhone = true;
              this.$refs.reviewSummaryRef.$refs[`${message}Phone`].classList.add("e-error");
              // eslint-disable-next-line no-param-reassign
              contactRef.errorLabelMessagePhone = "Please enter valid phone number";
              this.errorsArray.push("Applicant phone is required (applicant page)");
            } else {
              this.validatePhone(
                obj.phone,
                "Phone",
                message,
                contactRef,
                "showErrorLabelPhone",
                "errorLabelMessagePhone",
              );
            }
            break;
          case "altPhone":
            this.validatePhone(
              obj.altPhone,
              "AltPhone",
              message,
              contactRef,
              "showErrorLabelAltPhone",
              "errorLabelMessageAltPhone",
              true,
            );
            break;
        }
      });
    },

    validatePhone(
      phone,
      phoneprop,
      message,
      contactRef,
      errorLabelProp,
      errorLabelMessageProp,
      isAlternate = false,
    ) {
      const phoneRef = `${message}${phoneprop}`;
      const regex = new RegExp(phoneRuleRegEx);
      if (phone && !regex.test(phone)) {
        this.errorsArray.push(
          `Please enter ${message} ${
            isAlternate ? "alternate" : ""
          } phone number in valid format (${message} page)`,
        );
        const reviewSummLabel = `${message}${isAlternate ? "AltPhone" : "Phone"}`;
        // eslint-disable-next-line no-param-reassign
        contactRef[errorLabelProp] = true;
        // eslint-disable-next-line no-param-reassign
        contactRef[errorLabelMessageProp] = "Please enter valid phone number";
        contactRef.$refs[phoneRef].classList.add("e-error");
        this.$refs.reviewSummaryRef.$refs[reviewSummLabel].classList.add("e-error");
      } else {
        contactRef.$refs[phoneRef].classList.remove("e-error");
        this.$refs.reviewSummaryRef.$refs[phoneRef].classList.remove("e-error");
      }
    },

    validateEmail(email, message, contactRef) {
      const emailRef = `${message}Email`;
      const regex = new RegExp(emailRuleRegEx);
      const isValid = regex.test(email);
      if (email && !isValid) {
        this.errorsArray.push(`Please enter ${message} email in valid format (${message} page)`);
        contactRef.$refs[emailRef].classList.add("e-error");
        // eslint-disable-next-line no-param-reassign
        contactRef.showErrorLabelEmail = true;
        // eslint-disable-next-line no-param-reassign
        contactRef.errorLabelMessageEmail = "Please provide a valid Email.";
        this.$refs.reviewSummaryRef.$refs[emailRef].classList.add("e-error");
      } else {
        contactRef.$refs[emailRef].classList.remove("e-error");
        this.$refs.reviewSummaryRef.$refs[emailRef].classList.remove("e-error");
      }
    },

    validatePermitValues() {
      try {
        this.errorsArray = [];
        const { applicantRef } = this.$refs;
        const { ownerRef } = this.$refs;
        const { contractorRef } = this.$refs;
        const { installerDetailsRef } = this.$refs;
        const { facilityTankInfoRef } = this.$refs;

        // validating dates
        const requiredMessage = "This field is required";
        const { projectInfoRef } = this.$refs;
        const { estStartDate } = this.permit;

        const estStartDateRef = projectInfoRef.$refs.estStartDateRef.$refs.estStartDate;
        if (!estStartDate || estStartDate !== "") {
          if (
            !this.validateDate(
              estStartDate,
              "estimated commencement date",
              estStartDateRef,
              "project location",
            )
          ) {
            projectInfoRef.$refs.estStartDateRef.showErrorLabel = true;
            projectInfoRef.$refs.estStartDateRef.errorLabelMessage = "Please enter a valid date";
            this.$refs.reviewSummaryRef.$refs.estStartDate.classList.add("e-error");
          } else {
            this.$refs.reviewSummaryRef.$refs.estStartDate.classList.remove("e-error");
          }
        }
        const { estEndDate } = this.permit;
        const estEndDateRef = projectInfoRef.$refs.estEndDateRef.$refs.estEndDate;
        if (!estEndDate || estEndDate !== "") {
          if (
            !this.validateDate(
              estEndDate,
              "estimated completion date",
              estEndDateRef,
              "project location",
            )
          ) {
            projectInfoRef.$refs.estEndDateRef.showErrorLabel = true;
            projectInfoRef.$refs.estEndDateRef.errorLabelMessage = "Please enter a valid date";
            this.$refs.reviewSummaryRef.$refs.estEndDate.classList.add("e-error");
          } else {
            this.$refs.reviewSummaryRef.$refs.estEndDate.classList.remove("e-error");
          }
        }
        // --------------- Description of Work
        const { workDesc } = this.permit;
        if (!workDesc) {
          this.errorsArray.push(
            'Description of Work required (project location page)',
          );
          projectInfoRef.showErrorWorkDesc = true;
          projectInfoRef.workDescMessage = requiredMessage;
          projectInfoRef.$refs.descriptionOfWork.classList.add("e-error");
          this.$refs.reviewSummaryRef.$refs.workDesc.classList.add("e-error");
        } else {
          projectInfoRef.$refs.descriptionOfWork.classList.remove("e-error");
          this.$refs.reviewSummaryRef.$refs.workDesc.classList.remove("e-error");
        }
        // --------------- Commercial Liability/Property Insurer
        const { propertyInsurer } = this.permit;
        if (!propertyInsurer) {
          this.errorsArray.push(
            'Commercial Liability/Property Insurer required (project location page)',
          );
          projectInfoRef.showErrorPropertyInsurer = true;
          projectInfoRef.propertyInsurerMessage = requiredMessage;
          projectInfoRef.$refs.propertyInsurer.classList.add("e-error");
          this.$refs.reviewSummaryRef.$refs.propertyInsurer.classList.add("e-error");
        } else {
          projectInfoRef.$refs.propertyInsurer.classList.remove("e-error");
          this.$refs.reviewSummaryRef.$refs.propertyInsurer.classList.remove("e-error");
        }
        // --------------- Policy #
        const { policyNo } = this.permit;
        if (!policyNo) {
          this.errorsArray.push(
            'Policy # required (project location page)',
          );
          projectInfoRef.showErrorPolicyNo = true;
          projectInfoRef.policyNoMessage = requiredMessage;
          projectInfoRef.$refs.policyNo.classList.add("e-error");
          this.$refs.reviewSummaryRef.$refs.policyNo.classList.add("e-error");
        } else {
          projectInfoRef.$refs.policyNo.classList.remove("e-error");
          this.$refs.reviewSummaryRef.$refs.policyNo.classList.remove("e-error");
        }
        // Validate Permit applicant Field
        if (applicantRef) {
          const { owner, contractor, engineer } = applicantRef.$refs;
          if (!owner.checked && !contractor.checked && !engineer.checked) {
            applicantRef.showPermitApplicantValidationError = true;
            this.errorsArray.push("Permit applicant  is required (applicant page)");
            this.$refs.reviewSummaryRef.$refs.permitApplicantInReview.classList.add("e-error");
          } else {
            applicantRef.showPermitApplicantValidationError = false;
            this.$refs.reviewSummaryRef.$refs.permitApplicantInReview.classList.remove("e-error");
          }
        }

        if (!this.permit.applicantContact.fName) {
          const appRef = applicantRef.$refs.applicantContactRef;
          appRef.$refs.ApplicantName.classList.add("e-error");
          appRef.showErrorLabelName = true;
          this.errorsArray.push("Applicant name is required (applicant page)");
          this.$refs.reviewSummaryRef.$refs.applicantName.classList.add("e-error");
        } else {
          this.$refs.reviewSummaryRef.$refs.applicantName.classList.remove("e-error");
        }

        // ------------------------ End validating dates --------------------
        // validating contacts
        this.validateContact(
          this.permit.applicantContact,
          "applicant",
          applicantRef.$refs.applicantContactRef,
        );
        this.validateContact(
          this.permit.contractorContact,
          "contractor",
          contractorRef.$refs.contractorContactRef,
        );
        this.validateContact(
          this.permit.installerContact,
          "installer",
          installerDetailsRef.$refs.installerContactRef,
        );
        this.validateContact(
          this.permit.engineerContact,
          "engineer",
          installerDetailsRef.$refs.engineerContactRef,
        );
        this.validateContact(
          this.permit.ePermitSite.ownerContact,
          "owner",
          ownerRef.$refs.ownerContactRef,
        );

        const { tssaId } = this.permit.installerContact;
        const { cpcaId } = this.permit.installerContact;
        const { comments } = this.permit.installerContact;
        if (!tssaId && !cpcaId && !comments) {
          installerDetailsRef.$refs.installerDetailsComments.classList.add("e-error");
          installerDetailsRef.showCommentsValidation = true;
          this.errorsArray.push("CPCA or TSSA ID or comment is required (Installer Details)");
          this.$refs.reviewSummaryRef.$refs.installerComments.classList.add("e-error");
        } else {
          this.$refs.reviewSummaryRef.$refs.installerComments.classList.remove("e-error");
        }

        const missingDetailsApplicationWorkList = this.applicationWorkLists.find(
          (applicationWorkList) => applicationWorkList.answerValue == null,
        );
        if (missingDetailsApplicationWorkList) {
          this.errorsArray.push("Missing details (Installation Information)");
        }
        // ----------------------------- End validating contacts ---------------

        const tankInfoPage = "(facility/tank page)";
        const { reviewSummaryRef } = this.$refs;
        // validating FacilityType
        const { facilityType } = this.permit.ePermitSite;
        const { facilityTypeLabelRef } = facilityTankInfoRef.$refs;
        const { facilityTypeDescRef } = facilityTankInfoRef.$refs;
        if (!facilityType || facilityType === "") {
          facilityTypeLabelRef.classList.add("e-error");
          facilityTankInfoRef.facilityTypeLabel = requiredMessage;
        // eslint-disable-next-line no-unused-expressions
        reviewSummaryRef.$refs.facilityTypeLabel?.classList.add("e-error");
        this.errorsArray.push(`Facility type is required ${tankInfoPage}`);
        } else {
        // eslint-disable-next-line no-unused-expressions
        reviewSummaryRef.$refs.facilityTypeLabel?.classList.remove("e-error");
        if (facilityType.toLowerCase() === "other" && !this.permit.ePermitSite.facilityTypeOther) {
          // eslint-disable-next-line no-unused-expressions
          facilityTypeDescRef?.classList.add("e-error");
          facilityTankInfoRef.showErrorLabelFacilityTypeOther = true;
          facilityTankInfoRef.errorLabelMessageFacilityTypeOtherDesc = requiredMessage;
          // eslint-disable-next-line no-unused-expressions
          reviewSummaryRef.$refs.facilityTypeDescLabel?.classList.add("e-error");
          this.errorsArray.push(
            `Please enter facility type details (facility/tank page) ${tankInfoPage}`,
          );
        } else {
          // eslint-disable-next-line no-unused-expressions
          reviewSummaryRef.$refs.facilityTypeDescLabel?.classList.remove("e-error");
        }
        }

        // validating permit type
        const { permitTypeLabelRef } = facilityTankInfoRef.$refs;
        if (
          !this.permit.isInstallation
        && !this.permit.isRemoval
        && !this.permit.isPipingReplacement
        ) {
          permitTypeLabelRef.classList.add("e-error");
          facilityTankInfoRef.permitTypeLabel = requiredMessage;
          reviewSummaryRef.$refs.permitTypeLabel.classList.add("e-error");
          this.errorsArray.push(`Please select permit type ${tankInfoPage}`);
        } else {
          reviewSummaryRef.$refs.permitTypeLabel.classList.remove("e-error");
        }

        // validating supplier/removal company
        if (!this.permit.isOilRemovalCompany && !this.permit.abovegroundFuelSupply) {
          facilityTankInfoRef.$refs.supplierCompanyLabelRef.classList.add("e-error");
          facilityTankInfoRef.supplierCompanyLabel = requiredMessage;
          this.errorsArray.push(`Supplier/Removal Company information is required ${tankInfoPage}`);
        } else if (
          !this.permit.ePermitSite.oilRemovalCompanyDesc
        || this.permit.ePermitSite.oilRemovalCompanyDesc === ""
        ) {
        // eslint-disable-next-line no-unused-expressions
        facilityTankInfoRef.$refs.oilRemovalCompanyDescRef?.classList.add("e-error");
        facilityTankInfoRef.showErrorLabelOilRemovalCompanyDesc = true;
        facilityTankInfoRef.errorLabelMessageOilRemovalCompanyDesc = requiredMessage;
        this.errorsArray.push(
          `Supplier/Removal Company information details are required ${tankInfoPage}`,
        );
        }

        if (
          (!this.permit.isOilRemovalCompany
          && !this.permit.abovegroundFuelSupply
          && !this.permit.ePermitSite.oilRemovalCompanyDesc)
        || this.permit.ePermitSite.oilRemovalCompanyDesc === ""
        ) {
          reviewSummaryRef.$refs.supplierCompanyLabel.classList.add("e-error");
        } else {
          reviewSummaryRef.$refs.supplierCompanyLabel.classList.remove("e-error");
        }

        // validating tanks
        const tanks = this.permit.ePermitSite.eSiteTanks;
        let isTankRequired = false;
        if (!tanks || tanks?.length === 0) {
          if (this.permit.productCode === "STSWP" || this.permit.productCode === "STSRP") {
            this.errorsArray.push(
              `Atleast one ${
                this.permit.productCode === "STSWP" ? "installation" : "removal"
              } tank is required ${tankInfoPage}`,
            );
            isTankRequired = true;
          }
        } else {
          if (this.permit.productCode === "STSRWP") {
            const isInstall = tanks.find((x) => x.isInstallationTank === true);
            const isRemoval = tanks.find((x) => x.isRemovalTank === true);
            if (!isInstall) {
              this.errorsArray.push(`Atleast one installation tank is required ${tankInfoPage}`);
              isTankRequired = true;
            }
            if (!isRemoval) {
              this.errorsArray.push(`Atleast one removal tank is required ${tankInfoPage}`);
              isTankRequired = true;
            }
          }
          if (
            !isTankRequired
          && tanks.find((tank) => tank.tankType !== "Aboveground < 8,000 liters")
          && !this.documents?.find(
            (x) => x.appDocument.documentType.toLowerCase() === "engineered drawings",
          )
          ) {
            this.errorsArray.push("Upload Engineering drawing below");
          }

          if (
            !isTankRequired
          && !this.documents?.find((x) => x.appDocument.documentType.toLowerCase() === "site diagram")
          ) {
            this.errorsArray.push("Upload Site Diagram below");
          }
          if (!isTankRequired) {
          // eslint-disable-next-line no-plusplus
            for (let i = 0; i < tanks.length; i++) {
              const tank = tanks[i];
              const tankNumber = i + 1;
              const typeofRef = tank.isRemovalTank
                ? `removal${tank.ascaTankNumber}`
                : `installation${tank.ascaTankNumber}`;
              const reff = facilityTankInfoRef.$refs[typeofRef][0];
              const tankRefs = reff.$refs;
              const reviewRefForTank = reviewSummaryRef.$refs;
              // ------------------------------ AST fields ---------------------------------------

              if (!tank.tankType) {
                this.errorsArray.push(
                  `Tank type is required for tank #${tankNumber} ${tankInfoPage}`,
                );
                tankRefs.tankTypeRef.classList.add("e-error");
                reff.tankTypeMessage = requiredMessage;
                reviewRefForTank[`tankType${tank.ascaTankNumber}`][0].classList.add("e-error");
              } else {
                reviewRefForTank[`tankType${tank.ascaTankNumber}`][0].classList.remove("e-error");
              }

              if (tank.isInstallationTank) {
                const AstDropdownVal = tank.forASTsOnly;
                if (!AstDropdownVal) {
                  tankRefs.forAstRef.classList.add("e-error");
                  reff.forASTMessage = requiredMessage;
                  reviewRefForTank[`forASTsOnly${tank.ascaTankNumber}`][0].classList.add("e-error");
                } else {
                  reviewRefForTank[`forASTsOnly${tank.ascaTankNumber}`][0].classList.remove(
                    "e-error",
                  );
                }
                if (tank.forASTsOnly && !tank.atsSingleWall && !tank.atsDoubleWall) {
                  this.errorsArray.push(
                    `AST single or double wall value is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  if (AstDropdownVal?.toLowerCase() === "single wall") {
                  // eslint-disable-next-line no-unused-expressions
                  tankRefs.forSingleWallRef?.classList.add("e-error");
                  reff.singleWallMessage = requiredMessage;
                  reviewRefForTank[`singleDoubleWall${tank.ascaTankNumber}`][0].classList.add(
                    "e-error",
                  );
                  } else {
                  // eslint-disable-next-line no-unused-expressions
                  tankRefs.forDoubleWallRef?.classList.add("e-error");
                  reff.doubleWallMessage = requiredMessage;
                  reviewRefForTank[`singleDoubleWall${tank.ascaTankNumber}`][0].classList.add(
                    "e-error",
                  );
                  }
                } else if (tank.atsSingleWall || tank.atsDoubleWall) {
                  reviewRefForTank[`singleDoubleWall${tank.ascaTankNumber}`][0].classList.remove(
                    "e-error",
                  );
                }
              }

              // ----------------------------------------------------------------------------
              if (!tank.constructionType) {
                this.errorsArray.push(
                  `ULC/API dropdown value is required for tank #${tankNumber} ${tankInfoPage}`,
                );
                tankRefs.forUlcApiRef.classList.add("e-error");
                reff.ulcApiMessage = requiredMessage;
                reviewRefForTank[`ulcAPI${tank.ascaTankNumber}`][0].classList.add("e-error");
              } else {
                reviewRefForTank[`ulcAPI${tank.ascaTankNumber}`][0].classList.remove("e-error");
              }
              if (
              tank.constructionType?.toLowerCase().includes("other")
              && (!tank.constructionDesc || tank.constructionDesc === "")
              ) {
                this.errorsArray.push(
                  `ULC/API dropdown description is required for tank #${tankNumber} ${tankInfoPage}`,
                );
              // eslint-disable-next-line no-unused-expressions
              tankRefs.forUlcApiDescRef?.classList.add("e-error");
              reff.constructionDescMessage = requiredMessage;
              reff.showErrorConstructionDesc = true;
              reviewRefForTank[`ulcApiDesc${tank.ascaTankNumber}`][0].classList.add("e-error");
              } else if (tank.constructionDesc) {
                reviewRefForTank[`ulcApiDesc${tank.ascaTankNumber}`][0].classList.remove("e-error");
              }

              if (tank.isInstallationTank) {
                if (!tank.custTankNumber || tank.custTankNumber === "") {
                  this.errorsArray.push(
                    `Customer tank number is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  tankRefs.customerTankNumberRef.classList.add("e-error");
                  reff.custTankNumberMessage = requiredMessage;
                  reff.showErrorCustTankNumber = true;
                  reviewRefForTank[`custTankNo${tank.ascaTankNumber}`][0].classList.add("e-error");
                } else {
                  reviewRefForTank[`custTankNo${tank.ascaTankNumber}`][0].classList.remove("e-error");
                }
              }

              if (tank.isInstallationTank) {
                if (!tank.serialNo || tank.serialNo === "") {
                  this.errorsArray.push(
                    `Tank serial number is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  tankRefs.tankSerialNumberRef.classList.add("e-error");
                  reff.serialNoMessage = requiredMessage;
                  reff.showErrorSerialNo = true;
                  reviewRefForTank[`tankSerialNo${tank.ascaTankNumber}`][0].classList.add("e-error");
                } else {
                  reviewRefForTank[`tankSerialNo${tank.ascaTankNumber}`][0].classList.remove(
                    "e-error",
                  );
                }
              }

              if (!tank.capacity || tank.capacity === "") {
                this.errorsArray.push(
                  `Tank capacity is required for tank #${tankNumber} ${tankInfoPage}`,
                );
                tankRefs.tankCapacityRef.classList.add("e-error");
                reff.capacityMessage = requiredMessage;
                reff.showErrorCapacity = true;
                reviewRefForTank[`tankCapacity${tank.ascaTankNumber}`][0].classList.add("e-error");
              } else {
                reviewRefForTank[`tankCapacity${tank.ascaTankNumber}`][0].classList.remove("e-error");
              }

              if (!tank.contentsType) {
                this.errorsArray.push(
                  `Type of products stored in tank is required for tank #${tankNumber} ${tankInfoPage}`,
                );
                tankRefs.tankContentTypeRef.classList.add("e-error");
                reff.contentsTypeMessage = requiredMessage;
                reviewRefForTank[`contentsType${tank.ascaTankNumber}`][0].classList.add("e-error");
              } else {
                reviewRefForTank[`contentsType${tank.ascaTankNumber}`][0].classList.remove("e-error");
              }

              if (tank.isInstallationTank) {
                if (!tank.tankLeakDetection) {
                  this.errorsArray.push(
                    `Tank leak detection field is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  tankRefs.tankLeakDetectionRef.classList.add("e-error");
                  reff.tankLeakDetectionMessage = requiredMessage;
                  reviewRefForTank[`tankLeakDetection${tank.ascaTankNumber}`][0].classList.add(
                    "e-error",
                  );
                } else {
                  reviewRefForTank[`tankLeakDetection${tank.ascaTankNumber}`][0].classList.remove(
                    "e-error",
                  );
                }
              }

              if (tank.isInstallationTank) {
                if (
                  (tank.tankLeakDetection?.toLowerCase().includes("other")
                  && !tank.tankLeakDetectionDescription)
                || tank.tankLeakDetectionDescription === ""
                ) {
                  this.errorsArray.push(
                    `Tank leak detection description is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                // eslint-disable-next-line no-unused-expressions
                tankRefs.tankLeakDetectionDescRef?.classList.add("e-error");
                reff.tankLeakDetectionDescMessage = requiredMessage;
                reff.showErrorTankLeakDetectionDesc = true;
                reviewRefForTank[`tankLeakDetectionDesc${tank.ascaTankNumber}`][0].classList.add(
                  "e-error",
                );
                } else if (tank.tankLeakDetectionDescription) {
                  reviewRefForTank[`tankLeakDetectionDesc${tank.ascaTankNumber}`][0].classList.remove(
                    "e-error",
                  );
                }
              }

              if (tank.isInstallationTank) {
                if (!tank.spillContainmentSystem) {
                  this.errorsArray.push(
                    `Tank spill containment system value is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  tankRefs.tankSpillContainmentSystemRef.classList.add("e-error");
                  reff.spillContainmentSystemMessage = requiredMessage;
                  reviewRefForTank[`spill${tank.ascaTankNumber}`][0].classList.add("e-error");
                } else {
                  reviewRefForTank[`spill${tank.ascaTankNumber}`][0].classList.remove("e-error");
                }
              }

              if (tank.isInstallationTank) {
                if (!tank.overfillProtection) {
                  this.errorsArray.push(
                    `Tank overfill protection value is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  tankRefs.tankOverfillProtectionRef.classList.add("e-error");
                  reff.overfillProtectionMessage = requiredMessage;
                  reviewRefForTank[`overfill${tank.ascaTankNumber}`][0].classList.add("e-error");
                } else {
                  reviewRefForTank[`overfill${tank.ascaTankNumber}`][0].classList.remove("e-error");
                }
              }

              if (tank.isInstallationTank) {
                if (
                  (tank.overfillProtection?.toLowerCase().includes("other")
                  && !tank.overfillProtectionDescription)
                || tank.overfillProtectionDescription === ""
                ) {
                  this.errorsArray.push(
                    `Tank overfill protection description is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                // eslint-disable-next-line no-unused-expressions
                tankRefs.tankOverfillProtectionDescRef?.classList.add("e-error");
                reff.overfillProtectionDescMessage = requiredMessage;
                reff.showErrorOverfillProtectionDesc = true;
                reviewRefForTank[`overfillDesc${tank.ascaTankNumber}`][0].classList.add("e-error");
                } else if (tank.overfillProtectionDescription) {
                  reviewRefForTank[`overfillDesc${tank.ascaTankNumber}`][0].classList.remove(
                    "e-error",
                  );
                }
              }

              if (tank.isInstallationTank) {
                if (!tank.sump) {
                  this.errorsArray.push(
                    `Tank sump field is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  tankRefs.tankSumpRef.classList.add("e-error");
                  reff.sumpMessage = requiredMessage;
                  reviewRefForTank[`sumps${tank.ascaTankNumber}`][0].classList.add("e-error");
                } else {
                  reviewRefForTank[`sumps${tank.ascaTankNumber}`][0].classList.remove("e-error");
                }
              }

              if (tank.isRemovalTank) {
                if (!tank.removalReasonType) {
                  this.errorsArray.push(
                    `Reason for removal is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  tankRefs.reasonForRemovalRef.classList.add("e-error");
                  reff.removalReasonMessage = requiredMessage;
                  reviewRefForTank[`reasonForRemoval${tank.ascaTankNumber}`][0].classList.add(
                    "e-error",
                  );
                } else {
                  reviewRefForTank[`reasonForRemoval${tank.ascaTankNumber}`][0].classList.remove(
                    "e-error",
                  );
                }
              }

              if (tank.isRemovalTank) {
                if (
                  !tank.isPipingBeingRemoved
                && !tank.pipingBeingRemovedExplain
                && tank.pipingBeingRemovedExplain !== ""
                ) {
                  this.errorsArray.push(
                    `Reason for removal description is required for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  tankRefs.isPipingRemovedDescRef.classList.add("e-error");
                  reff.isPipingBeingRemovedDescMessage = requiredMessage;
                  reff.showErrorIsPipingBeingRemovedDesc = true;
                  reviewRefForTank[`reasonForRemovalDesc${tank.ascaTankNumber}`][0].classList.add(
                    "e-error",
                  );
                } else if (!tank.isPipingBeingRemoved) {
                  reviewRefForTank[`reasonForRemovalDesc${tank.ascaTankNumber}`][0].classList.remove(
                    "e-error",
                  );
                }
              }

              if (tank.isInstallationTank) {
                if (!tank.splitType) {
                  this.errorsArray.push(
                    `Please select split type for tank #${tankNumber} ${tankInfoPage}`,
                  );
                  tankRefs.tankSplitRef.classList.add("e-error");
                  reff.splitTypeMessage = requiredMessage;
                  reviewRefForTank[`splitType${tank.ascaTankNumber}`][0].classList.add("e-error");
                } else {
                  reviewRefForTank[`splitType${tank.ascaTankNumber}`][0].classList.remove("e-error");
                }
              }
            }
          }
        }
      } catch (err) {
        console.error('Error occured on validation ', err);
      }
    },

    async onSubmitAppl() {
      if (this.permit.printName) {
        await submitApplication(this.permit)
          .then((resp) => {
            this.showToastNotification(
              "Success !",
              "Application submitted successfully",
              "e-toast-success",
            );
            // -- rederecty to payment page.
            // -- Leo 2022-07-04
            const invoice = resp.data;
            this.$router.push({
              name: "PayByRequest",
              params: {
                requestId: invoice.applicationRequestRequestId,
              },
            });
            // this.$router.push("/reports/transactions");
          })
          .catch(() => {
            this.showToastNotification(
              "Error !",
              "Error occurred while submitting application",
              "e-toast-danger",
            );
          });
      } else {
        this.$refs.reviewSummaryRef.$refs.applicantNameAuth.classList.add("e-error");
      }
    },
  },
};
</script>

<style>
@import "../../../assets/styles/eservices-base.css";

.custom-invisible {
  visibility: hidden;
}
.sub-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 5%;
}
.main-container {
  display: grid;
  grid-gap: 10px;
  padding: 10px;
  border-style: groove;
}
div.e-error .e-float-input.e-control-wrapper > label.e-float-text.e-label-top {
  color: red !important;
}
.e-error {
  color: red;
}
.dialog {
  max-height: 20% !important;
  max-width: 60% !important;
  left: 20% !important;
  top: 10% !important;
}
</style>
<style>
@import "../../../assets/styles/eservices-permitting.css";
</style>
